<button
  type="button"
  class="cads-icon-tile-button"
  [disabled]="config().disabled"
  [ngStyle]="_interactionVars()"
  (click)="_onActivate()"
>
  <cads-icon-view-bit [config]="_iconConfig()" />
  <span class="cads-icon-tile-button__label">{{ config().label }}</span>
</button>
